// extracted by mini-css-extract-plugin
module.exports = {"partyTag":"party-tag-module--party-tag--3yYKI","dark":"party-tag-module--dark--2GDNI"};